import axios from 'axios';
import { getItem, STORAGE_KEYS } from '../../../services/storage';

// Resuelve el baseURL del backend Node según el deployment.
const baseUrlPorDeployment = (deployment) => {
  if (deployment === 'local') return 'http://localhost:4000';
  if (deployment === 'test') return 'https://apis.testn.cedetecgroup.com';
  return 'https://apis.n.cedetecgroup.com';
};

// Instancia axios para el flujo de auto-matrícula.
// A diferencia de la versión anterior (que parseaba localStorage una única vez en
// tiempo de import y dejaba el token fijado en el módulo), el token se inyecta por
// petición desde la misma fuente canónica que HttpService (getItem(STORAGE_KEYS.USER)).
// Esto evita tokens caducos cuando el usuario inicia sesión después de cargar el
// bundle y elimina la lectura de credenciales en el import del módulo.
export const Instancia = (deployment) => {
  const instance = axios.create({
    baseURL: baseUrlPorDeployment(deployment),
    timeout: 0,
    headers: {
      'content-type': 'application/json',
    },
  });

  instance.interceptors.request.use((reqConfig) => {
    const user = getItem(STORAGE_KEYS.USER);
    if (user?.tokenId) {
      reqConfig.headers.Authorization = `Bearer ${user.tokenId}`;
    }
    return reqConfig;
  });

  return instance;
};
